import React from 'react';
import Link from 'next/link';
import { Category, Company } from '../../models';
import { AllyCard } from '../ally';

interface SectionRowProps {
  category: Category;
  allies?: Company[];
}

function SectionRow({ category, allies }: SectionRowProps) {
  return (
    <div className="w-full flex flex-col gap-5">
      <div className="flex flex-row gap-2 items-end">
        <p className="text-neutral-cold-800 text-lg lg:text-xl text-left font-semibold">
          {category?.name}
        </p>
        <Link href={`/category/${category?._id}`}>
          <p className="text-purple-300 hover:text-purple-100">
            Explorar todos
          </p>
        </Link>
      </div>
      <div className="w-full  flex flex-row gap-5 ml-5">
        {allies?.slice(0, 5).map((ally: Company, index: number) => (
          <AllyCard key={index} ally={ally} categoryId={category?._id} />
        ))}
      </div>
    </div>
  );
}

export default SectionRow;
